<ion-header>
  <ion-toolbar mode="md">
    <ion-title size="small">
      <ion-text style="font-size: medium">
        {{ "reservation-app.date-comment" | translate }}</ion-text
      >
    </ion-title>
    <ion-button
      (click)="closeModal()"
      size="small"
      slot="end"
      fill="clear"
      color="dark"
    >
      <ion-icon slot="icon-only" src="assets/ionicons/close.svg"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-item lines="none">
    <ion-textarea class="custom" type="text" [autoGrow]="true" rows="3" [placeholder]="'write-here' | translate" [(ngModel)]="comment"></ion-textarea>
  </ion-item>
</ion-content>

<ion-footer>
  <ion-grid>
    <ion-row style="width: 100%">
      <ion-col style="padding: 0; margin: 0" size="12" class="ion-text-center">
        <ion-button
          [disabled]="loading"
          size="medium"
          (click)="update_comment()"
        >
          <ion-text *ngIf="!loading">{{ "save" | translate }}</ion-text>
          <ion-spinner *ngIf="loading"></ion-spinner>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>